import React, { useState, useRef, useEffect } from "react";
import Dropdown from "../../../../Components/Dropdown";
import Input from "../../../../Components/Input";
import DateInput from "../../../../Components/DateInput";
import TextInput from '../../../../Components/TextInput'
import search from '../../../../Assets/Icons/search.png';
import uploadIcon from '../../../../Assets/Icons/upload.png';
import deleteIcon from '../../../../Assets/Icons/delete.png';
import ReminderRegisterController from "../../../Controllers/AdminScreens/Configuration/ReminderRegisterController";
import Loader from "../../../../Components/Loader";
import { getLocalDateTime } from '../../../../Utils/Validation';
import downArrow from '../../../../Assets/Icons/chevron-down.png';
import DeleteConfirmationModal from '../../../../Components/Modals/DeleteConformationModal'
import TemplatePreview from "../../../../Components/TemplatePreview";

const ReminderRegisterScreen = () => {
  const {
    clientsList,
    selectList,
    setSelectList,
    selectClient,
    setSelectClient,
    channel,
    setChannel,
    selectTemplate,
    setSelectTemplate,
    messageContent,
    setMessageContent,
    scheduleFor,
    setScheduleFor,
    date,
    setDate, channelOptions,
    recipientSource,
    setRecipientSource,
    handleSearchClient,
    loading,
    setSearchUser,
    searchUser,
    clientList,
    error,
    handleSearchInputText,
    handleSelectClient,
    selectedClients,
    handleAddClient,
    addedClients,
    preview,
    setClientsList,
    setError,
    contactListList,
    contactListError,
    contactListLoading,
    contacttList,
    contactError,
    contactLoading,
    fetchContact,
    setContacttError,
    setContactList,
    currentContacts,
    totalPages,
    totalClientPages,
    currentClientPage,
    currentContactPage,
    handleClientPageChange,
    handleContactPageChange,
    currentClient,
    setCurrentClientPage,
    setCurrentContactPage,
    fetchTemplates,
    templateList,
    templateError,
    templateLoading,
    setTemplate,
    template,
    handleOpenDeleteModal,
    handleCloseDeleteModal,
    isDeleteModalOpen,
    setIsDeleteModalOpen,
    selectedDocument,
    setSelectedDocument,
    addClientError,
    handleSubmitReminder,
    submitReminderSuccess,
    submitReminderError,
    submitReminderLoading,
    channelSelectError,
    setContactListError,
    setChannelSelectError,
    setTemplateError,
    handleCancel,
    groupedContacts,
    setGroupedContacts,
    scheduleForError,
    setScheduleForError, isPreview,setIsPreview,
    setAddClientError, handleShowPreview,
  } = ReminderRegisterController();

  const [userPermissions, setUserPermissions] = useState(null);
  useEffect(() => {
    const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
    setUserPermissions(storedUserInfo?.user_permissions || {});
  }, [])

  const [openDropdown, setOpenDropdown] = useState(null); // Tracks the currently open dropdown
  const toggleDropdown = (dropdownName) => {
    setOpenDropdown((prev) => (prev === dropdownName ? null : dropdownName));
  };

  const dropdownRefs = useRef({}); // Ref for dropdown

  // Handle clicks outside dropdowns
  useEffect(() => {
    const handleClickOutside = (event) => {
      const isOutside = Object.keys(dropdownRefs.current).every(
        (key) => dropdownRefs.current[key] && !dropdownRefs.current[key].contains(event.target)
      );
      if (isOutside) {
        setOpenDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const maxVisiblePages = 3;

  const getVisiblePages = (currentPage, totalPages) => {
    const maxVisiblePages = 3;
    const startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    const endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
    const adjustedStartPage = Math.max(1, endPage - maxVisiblePages + 1);
    return Array.from({ length: endPage - adjustedStartPage + 1 }, (_, i) => adjustedStartPage + i);
  };

  const visibleContactPages = getVisiblePages(currentContactPage, totalPages);
  const visibleClientPages = getVisiblePages(currentClientPage, totalClientPages);

  return (
    <div style={styles.container}>
      <h3 style={styles.categoryHeader}>Send Reminder</h3>

      <div style={styles.row}>
        {/* Recipient Information */}
        <div style={styles.recipientCard}>
          <h4 style={styles.cardHeader}>Recipient Information</h4>
          <div className="basic-info-card" style={{ border: 'none', padding: '10px' }}>
            <div style={{ display: 'flex', gap: '20px', alignItems: 'center', marginBottom: '15px' }}>
              <label style={{ ...styles.labelStyle, display: 'flex', alignItems: 'center', gap: '5px' }}>
                <input
                  type="radio"
                  value="list"
                  checked={recipientSource === "list"}
                  onChange={() => {
                    setRecipientSource("list");
                    setClientsList([]);
                    setSearchUser('');
                    setError('');
                    setCurrentClientPage(1);
                    setAddClientError('')
                  }}
                />
                Select List
              </label>

              <label style={{ ...styles.labelStyle, display: 'flex', alignItems: 'center', gap: '5px' }}>
                <input
                  type="radio"
                  value="client"
                  checked={recipientSource === "client"}
                  onChange={() => {
                    setRecipientSource("client");
                    setSelectList("");
                    setContacttError('');
                    setContactList([])
                    setCurrentContactPage(1)
                    setContactListError('')
                    // setClientsList([]);
                  }}
                />
                Select Client
              </label>
            </div>

            {recipientSource === "list" ? (
              <Dropdown
                ref={(el) => (dropdownRefs.current["selectList"] = el)}
                isOpen={openDropdown === "selectList"}
                toggleDropdown={() => toggleDropdown("selectList")}
                label="Select List"
                options={contactListList || []}
                value={selectList}
                onChange={(selected) => {
                  setSelectList(selected);
                  if (selected?.value) {
                    fetchContact(selected.value);
                  } else {
                    setContactList([]);
                    setGroupedContacts({ whatsapp: [], email: [], sms: [] });
                  }
                  setContactListError('')
                }}
                errorMessage={contactListError}
                loading={contactListLoading}
                isClear={true}
              />
            ) : (
              <div className="filter-field" style={{ marginTop: "15px", width: '-webkit-fill-available' }}>
                <label style={{ ...styles.labelStyle, display: "block" }}>
                  Select Client
                </label>
                <TextInput
                  type="text"
                  placeholder="Search"
                  style={{ padding: "20px 10px" }}
                  value={searchUser}
                  onChange={(e) => handleSearchInputText(e.target.value)}
                  onRightClick={handleSearchClient}
                  right={
                    loading ? (
                      <Loader loading={loading} color={'var(--primary-loader-color)'} size='small' /> // Show loader when loading
                    ) : (
                      <img src={search} alt="Search" style={{ cursor: 'pointer', height: '20px', width: '20px' }} />
                    )
                  }
                  errorMessage={error}
                  width={280}
                />
                {clientList.length > 0 && (
                  <ul style={styles.dropdownList}>
                    {clientList.map((client, index) => (
                      <li
                        key={client?.client_id}
                        onClick={() => handleSelectClient(client)}
                        style={{
                          ...styles.dropdownItem,
                          borderBottom: index !== clientList.length - 1 ? '1px solid #ccc' : 'none', // Add line below except last item
                        }}
                      >
                        {client?.client_name}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            )}

            <div style={styles.buttonContainer}>
              {/* <button
                style={{
                  ...styles.addServiceButton,
                  paddingLeft: "12px",
                  paddingRight: "12px",
                  cursor: "pointer",
                }}
              >
                <img
                  src={uploadIcon}
                  style={{ ...styles.icon, cursor: "pointer" }}
                  alt="Upload Icon"
                />
                <span style={{ ...styles.buttonText, cursor: "pointer" }}>
                  Upload
                </span>
              </button> */}
              {recipientSource === "client" &&
                // userPermissions?.dashboard?.per_name_sub_json?.client_add === 1 && (
                <button style={styles.addServiceButton} onClick={handleAddClient}>
                  <span style={{ marginRight: "10px" }}>+</span> Add Client
                </button>
                // )
              }
            </div>
            {addClientError && <div className="list-error-msg">{addClientError} </div>}
            <div style={{ marginTop: "10px" }}>
              <table className="tasksScreen-task-table">
                <thead>
                  <tr>
                    <th style={{ width: "90%" }}>{recipientSource === 'list' ? 'List Contacts' : 'Clients'}</th>
                    <th style={{ width: "10%" }}></th>
                  </tr>
                </thead>
                <tbody style={{ backgroundColor: "white" }}>
                  {recipientSource === 'list'
                    ? currentContacts?.map((contact, index) => (
                      <tr key={index}>
                        <td style={styles.tableLink}>
                          {`${contact?.contact_name || '--'}, ${contact?.communication_channel || '--'}, ${contact?.communication_channel === 'whatsapp'
                            ? contact?.whatsapp_no || '--'
                            : contact?.communication_channel === 'phone'
                              ? contact?.contact_no || '--'
                              : contact?.communication_channel === 'email'
                                ? contact?.email_id || '--'
                                : '--'
                            }`}
                        </td>
                        <td>
                          <button
                            className="tasksScreen-delete-button"
                            style={{
                              border: "none",
                              background: "transparent",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setContactList(prev =>
                                prev.filter(
                                  (c) =>
                                    !(
                                      c.contact_name === contact?.contact_name &&
                                      c.communication_channel === contact?.communication_channel &&
                                      (
                                        c.whatsapp_no === contact?.whatsapp_no ||
                                        c.contact_no === contact?.contact_no ||
                                        c.email_id === contact?.email_id
                                      )
                                    )
                                )
                              );

                              setGroupedContacts(prev => {
                                const removeFromList = (list = []) =>
                                  list.filter(c =>
                                    !(
                                      c.contact_name === contact?.contact_name &&
                                      c.communication_channel === contact?.communication_channel &&
                                      (
                                        c.whatsapp_no === contact?.whatsapp_no ||
                                        c.contact_no === contact?.contact_no ||
                                        c.email_id === contact?.email_id
                                      )
                                    )
                                  );

                                return {
                                  whatsapp: removeFromList(prev.whatsapp),
                                  email: removeFromList(prev.email),
                                  sms: removeFromList(prev.sms)
                                };
                              });
                            }}

                          >
                            <img
                              src={deleteIcon}
                              alt="Delete"
                              style={{ width: "16px", height: "16px" }}
                            />
                          </button>
                        </td>
                      </tr>
                    ))
                    : currentClient?.map((client, index) => (
                      <tr key={index}>
                        <td style={styles.tableLink}>{client?.client_name}</td>
                        <td>
                          <button
                            className="tasksScreen-delete-button"
                            style={{
                              border: "none",
                              background: "transparent",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setClientsList(prev =>
                                prev.filter((c) => c.client_id !== client.client_id)
                              );
                            }}
                          >
                            <img
                              src={deleteIcon}
                              alt="Delete"
                              style={{ width: "16px", height: "16px" }}

                            />
                          </button>
                        </td>
                      </tr>
                    ))
                  }
                </tbody>

              </table>
              {contactError && <div className="list-error-msg">{contactError} </div>}
              {contactLoading && <Loader loading={contactLoading} color={'var(--primary-loader-color)'} />}
            </div>
            <div className="tasksScreen-table-footer">
              <span className="tasksScreen-pagination-info">
                {recipientSource === 'list'
                  ? `${currentContactPage}-${totalPages} of items`
                  : `${currentClientPage}-${totalClientPages} of items`}
              </span>

              <div className="tasksScreen-pagination">
                {recipientSource === 'list' ? (
                  <>
                    <button onClick={() => handleContactPageChange(currentContactPage - 1)} disabled={currentContactPage === 1} className="tasksScreen-pagination-button">
                      <img src={downArrow} alt="Previous" className="tasksScreen-arrow-right tasksScreen-icon-image " />
                    </button>
                    {visibleContactPages.map((page) => (
                      <button key={page} className={`tasksScreen-pagination-button ${currentContactPage === page ? "active" : ""}`} onClick={() => handleContactPageChange(page)}>
                        {page}
                      </button>
                    ))}
                    <button onClick={() => handleContactPageChange(currentContactPage + 1)} disabled={currentContactPage === totalPages} className="tasksScreen-pagination-button">
                      <img src={downArrow} alt="Next" className="tasksScreen-arrow-right tasksScreen-icon-image " />
                    </button>
                  </>
                ) : (
                  <>
                    <button onClick={() => handleClientPageChange(currentClientPage - 1)} disabled={currentClientPage === 1} className="tasksScreen-pagination-button">
                      <img src={downArrow} alt="Previous" className="tasksScreen-arrow-right tasksScreen-icon-image " />
                    </button>
                    {visibleClientPages.map((page) => (
                      <button key={page} className={`tasksScreen-pagination-button ${currentClientPage === page ? "active" : ""}`} onClick={() => handleClientPageChange(page)}>
                        {page}
                      </button>
                    ))}
                    <button onClick={() => handleClientPageChange(currentClientPage + 1)} disabled={currentClientPage === totalClientPages} className="tasksScreen-pagination-button">
                      <img src={downArrow} alt="Next" className="tasksScreen-arrow-right tasksScreen-icon-image " />
                    </button>
                  </>
                )}
              </div>
            </div>

          </div>
        </div>

        {/* Select Template */}
        <div style={styles.templateCard}>
          <h4 style={styles.cardHeader}>Select Template</h4>
          <div className="basic-info-card" style={{ border: 'none', padding: '10px' }}>
            <div style={styles.display}>
              <div style={{ flex: 'auto' }}>
                <Dropdown
                  ref={(el) => (dropdownRefs.current["channel"] = el)}
                  isOpen={openDropdown === "channel"}
                  toggleDropdown={() => toggleDropdown("channel")} label="Channel" options={channelOptions || []} value={channel}
                  onChange={(selected) => {
                    setChannel(selected);
                    fetchTemplates(selected);
                    setTemplate('');
                    setChannelSelectError('');
                    setIsPreview(false)
                  }} errorMessage={channelSelectError}
                // searchBoxWidth={190} 
                />
              </div><div style={{ flex: 'auto' }}>
                <Dropdown
                  ref={(el) => (dropdownRefs.current["template"] = el)}
                  isOpen={openDropdown === "template"}
                  toggleDropdown={() => toggleDropdown("template")} label="Select Template" options={templateList || []} value={template}
                  onChange={(selected) => {
                    setTemplate(selected);
                    setTemplateError('');
                    setIsPreview(false)
                    // fetchTemplates(selected);
                  }}
                  errorMessage={templateError}
                  loading={templateLoading}
                // searchBoxWidth={190}
                />
              </div>
            </div>
            {/* Rich Preview */}
            {/* {isPreview &&
            <div style={{ marginTop: '28px' }}>
              <div
                className="previewBox"
                dangerouslySetInnerHTML={{ __html: template?.template_text }}
              />
            </div>
            } */}
            {isPreview && (
              <div style={{padding:'20px 0px'}}><TemplatePreview
                channel={channel?.value}   // WHATSAPP | SMS | EMAIL
                body={template?.template_text ?? ''}
                subject={template?.label ?? ''}
                onClose={handleShowPreview}
              /></div>
            )}

            {template &&
              <div className="tasksScreen-cancel-button" onClick={handleShowPreview} style={{ width: 'fit-content', marginLeft: 'auto', marginTop: 20 }}>Preview</div>
            }
          </div>
        </div>

        {/* Scheduling Details */}
        <div style={styles.schedulingCard}>
          <h4 style={styles.cardHeader}>Scheduling Details</h4>
          <div
            className="basic-info-card"
            style={{ height: "auto", paddingBottom: "20px", border: 'none', padding: '10px' }}
          >
            <Dropdown
              ref={(el) => (dropdownRefs.current["scheduleFor"] = el)}
              isOpen={openDropdown === "scheduleFor"}
              toggleDropdown={() => toggleDropdown("scheduleFor")} label="Schedule for" options={["Now", "Later"]} value={scheduleFor}
              onChange={(value) => {
                setScheduleFor(value);
                setDate('');
                setScheduleForError('')
              }} errorMessage={scheduleForError} />
            <div className="filter-field" style={{ marginTop: "15px", width: '-webkit-fill-available' }}>
              <label style={{ ...styles.labelStyle, display: "block" }}>
                Date
              </label>
              <DateInput value={date} onChange={(e) => setDate(e.target.value)} isDateTime={true}
                min={getLocalDateTime()} disabled={scheduleFor === "Now"} />
            </div>
          </div>
          <div className="button-container" style={{ marginTop: '25px' }}>
            {/* <button className="add-client-button" style={{ paddingLeft: '30px', paddingRight: '30px', marginRight: '10px' }} onClick={handleSubmitReminder}>Submit Reminder</button> */}
            <button
              onClick={handleSubmitReminder}
              className="tasksScreen-apply-button"
              style={{
                cursor: submitReminderLoading ? "not-allowed" : "pointer",
                opacity: submitReminderLoading ? 0.6 : 1,
                pointerEvents: submitReminderLoading ? 'none' : 'auto',
                gap: '5px',
                display: 'flex'
              }}
              disabled={submitReminderLoading}
            >
              {submitReminderLoading && (
                <Loader loading={submitReminderLoading} color={'var(--background-color)'} size="small" />
              )}
              <span>Submit Reminder</span>
            </button>
            <button className="cancel-button" onClick={handleCancel}>Cancel</button>
          </div>
          {submitReminderError && <div className="list-error-msg">{submitReminderError} </div>}
          {submitReminderSuccess && <div className="list-success-msg">{submitReminderSuccess} </div>}
        </div>
      </div>
      {/* <DeleteConfirmationModal
  isOpen={isDeleteModalOpen}
  message={`Are you sure you want to delete ${selectedDocument?.contact_name}?`}
  onClose={handleCloseDeleteModal}
  onConfirm={() => {
    setContactList(prev =>
      prev.filter(
        (c) =>
          !(
            c.contact_name === selectedDocument?.contact_name &&
            c.communication_channel === selectedDocument?.communication_channel &&
            (
              c.whatsapp_no === selectedDocument?.whatsapp_no ||
              c.contact_no === selectedDocument?.contact_no ||
              c.email_id === selectedDocument?.email_id
            )
          )
      )
    );
    handleCloseDeleteModal();
  }}
/> */}

    </div>
  );
};

export default ReminderRegisterScreen;

const styles = {
  container: {
    padding: "20px",
    maxWidth: "90%",
    margin: "auto",
    backgroundColor: "#fff",
    //   border: "1px solid #ccc",
    borderRadius: "10px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    marginBottom: '50px',
    borderLeft: '1px solid var(--tab-border)'
  },
  categoryHeader: {
    color: "#1F384C",
    fontSize: 18,
    fontWeight: 500,
    paddingBottom: 20,
  },
  row: {
    display: "flex",
    flexWrap: "wrap",
    gap: "20px",
  },
  cardContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  cardHeader: {
    fontSize: "16px",
    fontWeight: "500",
    color: "var(--web-title-text-color)",
    marginBottom: "10px",
  },
  recipientCard: {
    flex: "1 1 20%", // Reduce width
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    minWidth: 240,
  },
  templateCard: {
    flex: "1 1 40%", // Keep the center card wider
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    minWidth: 240,
  },
  schedulingCard: {
    flex: "1 1 20%", // Reduce width
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    minWidth: 240,
  },
  labelStyle: {
    fontSize: "12px",
    fontWeight: "400",
    fontFamily: "Roboto",
    color: "rgb(52, 60, 68)",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "10px",

  },
  addServiceButton: {
    backgroundColor: "transparent",
    border: "1px #858585 solid",
    borderRadius: "28px",
    padding: "8px 12px",
    color: "#40513B",
    cursor: "pointer",
    fontSize: "12px",
    fontFamily: "Roboto",
    fontWeight: "400",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  textarea: {
    border: "1px solid #d1e3ed",
    borderRadius: "5px",
    fontSize: "14px",
    padding: "10px",
    resize: "none",
  },
  buttonGroup: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "20px",
  },
  submitButton: {
    backgroundColor: "#4CAF50",
    color: "#fff",
    padding: "10px 20px",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
  cancelButton: {
    backgroundColor: "#E0E0E0",
    padding: "10px 20px",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
  icon: {
    width: "12px",
    height: "12px",
    marginRight: "10px",
  },
  display: {
    display: 'flex',
    columnGap: '20px',
    rowGap: "20px",
    flexWrap: 'wrap'
  },
  dropdownList: {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    backgroundColor: '#fff',
    border: '1px solid #ccc',
    borderRadius: '4px',
    maxHeight: '200px',
    overflowY: 'auto',
    zIndex: 1000,
    padding: 0, // Remove default padding
    margin: 0, // Remove default margin
    listStyleType: 'none', // Remove the dots
  },
  dropdownItem: {
    padding: '10px',
    cursor: 'pointer',
    borderBottom: '1px solid #eee', // Default for all items
    backgroundColor: '#fff',
    hover: {
      backgroundColor: '#f0f0f0',
    },
  },
  categoryHeader: {
    color: "#1F384C",
    fontSize: 28,
    fontWeight: 500,
    paddingBottom: 0,
    fontFamily: "Roboto Slab"
  },
  cardHeader: {
    fontSize: "18px",
    fontWeight: "600",
    color: "var(--web-title-text-color)",
    marginBottom: "0px",
    fontFamily: "Roboto Slab"
  },
};

